import React, { useState, useEffect } from "react";
import commonDatas  from '../../apps/CommonDatas'

import './Top.css';

import { Link } from "react-router-dom";

export function Top () {
  let isCheck = commonDatas.getCookie("check");
	
  const [isShowPopup, setIsShowPopup] = useState((isCheck !== "true" ));
  const [isPopupCheck, setIsPopupCheck] = useState(false);
  const [isAttentionOpen, setIsAttentionOpen] = useState(false);
  
  const onOpenAttentionClick = (e) => {
	e.preventDefault();
	
	setIsAttentionOpen(!isAttentionOpen);
  } 
  const onPopupCheckClick = (e) => {
	e.preventDefault();	  
	setIsPopupCheck(!isPopupCheck);
  }
  const onPopupCloseClick = (e) => {
	e.preventDefault();
	if( isPopupCheck ){
		commonDatas.setCookie("check", "true");
	}
	setIsShowPopup(false);
  }
  useEffect(() => {
    document.getElementsByTagName("html")[0].scrollTop = 0;
	document.body.scrollTop = 0;
  }, []);
  return (
    <>
      <div id="top" className="content_wrapper">
        <h1 className="mb45"><img src="./images/top_header.png" width="100%" alt="ポケットモンスター おっとっとを買ってポケモンをさがしてみよう！" /></h1>

        <div className="mb35"><img src="./images/how_to_play.png" width="100%" alt="ポケモン大発見！ あそびかた  1. おっとっとを買う  2. ポケモンをみつける  3. みつけたポケモンのシルエットをえらぶ  4. 画面のフレームにポケモンをあわせる  5. ポケモンとフレームがはまった！ 全78種をみつけてみよう！あそべるのは2026年12月25日(金)11時まで！ 本コンテンツは、ポケモンの菓子型78種(うすしお味には全68種、コーンポタージュ味には全53種封入されております)をみつけるコンテンツのみとなります。すべてみつけたことでのプレゼントキャンペーンなどはございません。ご了承ください。" /></div>
        <div className="mb30"><img src="./images/txt_sound_attention.png" width="68.75%" alt="ゲーム中、マナーモードでも音声が再生されます。お使いの端末での設定ボリュームとなりますので、ご注意ください" /></div>
        <div className="mb50"><Link to="/list"><img src="./images/btn_start.png" width="84.0625%" alt="スタート" /></Link></div>
        <div className="mb50">
          <div className="attention_area">
            <div className="attention_header">
              <div className="pt25 pb25">ゲームを始める前に確認してね</div>
            </div>
            <div className={isAttentionOpen ? "attention_body attention_open" : "attention_body attention_close"}>
              <div className="attention_inner">
                <div className="attention_inner_header pt35 mb35">動作環境の確認</div>
                <div className="mb10 ml35 mr35 left">
                  <ul>
                    <li className="infomation mb20">本コンテンツはスマートフォンのみでご利用いただけます。</li>
                    <li className="infomation red mb15">推奨動作環境は、Android11.0以上<br />（Chrome）/ iOS15以上（safari）となります。</li>
                    <li className="attention red mb20">推奨動作環境であっても、古い端末や一部端末、端末の設定によっては動作しない場合がございます。ご了承下さい。</li>
                    <li className="infomation mb20"><p className="txt_notice">本コンテンツはCookieを使用しておりますので、菓子型収集中はCookieを削除されないようご注意ください。</p></li>
                    <li className="infomation mb20">本コンテンツはLINE連携をしていただくことで、菓子型収集の進捗を保存できます。</li>
                    <li className="infomation mb20">室内外の環境光によって認識しづらい場合がございます。</li>
                    <li className="infomation mb20">割れている・欠けている菓子は形を読み取れない可能性がございます。</li>
                    <li className="infomation mb20">菓子色と背景の色が似ていると認識しづらい場合がございます。その場合は濃い色の背景の上で読み取りください。</li>
                    <li className="infomation mb20">端末のカメラによっては認識しづらい場合がございます。</li>
                    <li className="infomation mb20">形を読み込む際は、菓子を置いておこなってください。</li>
                    <li className="infomation mb20">本コンテンツは2026年12月25日(金)11:00までご利用いただけます。</li>
                  </ul>
                </div>
              </div>
              <div className="btn_attention pb80">
                <div className="icon_area">
               	  <div className="icon_open"><img src="./images/icon_open.png" width="5.37%" alt="" /></div>
                   <div className="icon_close"><img src="./images/icon_close.png" width="5.37%" alt="" /></div>
                </div>
                <a href="/#" onClick={(e) => onOpenAttentionClick(e)}><span></span></a>
              </div>
            </div>
          </div>
        </div>
        <div className="pb30"><img src="./images/copyright.png" width="55.46875%" alt="©Nintendo・CR・GF・TX・SP・JK ©Pokémon" /></div>

        {isShowPopup ? <div id="check_popup">
          <div className="popup_inner">
            <div className="center">
              <div className="check_popup_header">
                <div className="pt25 pb25">動作環境の確認</div>
              </div>
              <div className="check_popup_body">
                <div className="pt30 mb40 ml35 mr35 left">
                  <ul>
                    <li className="infomation mb20">本コンテンツはスマートフォンのみでご利用いただけます。</li>
                    <li className="infomation red mb15">推奨動作環境は、Android11.0以上<br />（Chrome）/ iOS15以上（safari）となります。</li>
                    <li className="attention red mb20">推奨動作環境であっても、古い端末や一部端末、端末の設定によっては動作しない場合がございます。ご了承下さい。</li>
                    <li className="infomation mb20"><p className="txt_notice">本コンテンツはCookieを使用しておりますので、菓子型収集中はCookieを削除されないようご注意ください。</p></li>
                    <li className="infomation mb20">本コンテンツはLINE連携をしていただくことで、菓子型収集の進捗を保存できます。</li>
                    <li className="infomation mb20">室内外の環境光によって認識しづらい場合がございます。</li>
                    <li className="infomation mb20">割れている・欠けている菓子は形を読み取れない可能性がございます。</li>
                    <li className="infomation mb20">菓子色と背景の色が似ていると認識しづらい場合がございます。その場合は濃い色の背景の上で読み取りください。</li>
                    <li className="infomation mb20">端末のカメラによっては認識しづらい場合がございます。</li>
                    <li className="infomation mb20">形を読み込む際は、菓子を置いておこなってください。</li>
                    <li className="infomation mb20">本コンテンツは2026年12月25日(金)11:00までご利用いただけます。</li>
                  </ul>
                </div>
                <div className="mb30 check_line">
                  <div className="clear">
                    <a id="btn_popup_check" href="/#" onClick={(e) => onPopupCheckClick(e)}><img id="img_popup_check" src={isPopupCheck ? "./images/btn_check_on.png" : "./images/btn_check_off.png"} width="8.333%" alt="" /><img src="./images/txt_top_popup3.png" width="50%" alt="次回以降表示しない" /></a>
                  </div>
                </div>
                <div className="pb40"><a id="close_check_popup" href="/#" onClick={(e) => onPopupCloseClick(e)}><img src="./images/btn_ok.png" width="88.704%" alt="わかった" /></a></div>
              </div>
            </div>
          </div>
        </div> : null }
      </div>
    </>
  );
};